// removed by extract-text-webpack-plugin
module.exports = {"container":"_1U8uQasoonCoJse_85OWB1"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Ready/Title/Buttons/Download/styles.css
// module id = 2894
// module chunks = 0